import { useState, useEffect, useMemo } from 'react';
import { Formik, Form } from 'formik';
import { RenderIf, MedicalViewSummaryModal } from '../../../../components';
import { storeMedicalProvider } from '../../../../redux/actions/medicalProviders';
import { useSelector, useDispatch } from 'react-redux';
import { cancelCaseSubmission, formikRefCapture, isCaseSaved, preProcessedMedicalRecordsData } from '../../../../redux/actions/liabilty';
import { useParams } from 'react-router-dom';
import { confirm } from '../../../../utils/swal';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import FileUploadErrorModal from '../../../../utils/fileUploadErrorModal';
import { toaster } from "../../../../utils/toast";
import CaseFormFooter from "../../../../components/ui-control/CaseFormFooter";
import { ReactComponent as MedicalSummaryButtonIcon } from '../../../../assets/icons/MedicalSummaryButtonIcon.svg';
import MedicalProviderSec from '../../../../components/ui-control/MedicalProviderSec';
import ReorderMedicalProvider from '../../../../components/ui-control/ReorderMedicalProvider';

const AddMedicalProviderBillForm = ({ 
    onSubmit, 
    stepDecrement, 
    backToCases, 
    innerRef,
    plainTiffs,
    selectedTiffIndex,
    setSelectedTiffIndex,
    formSteps 
}) => {
    const [isOpenProcessedMedicalRecordsModal, setIsOpenProcessedMedicalRecordsModal] = useState(false);
    const { caseId } = useParams();
    const dispatch = useDispatch();
    const medicalProviderData = useSelector(state => state.medicalProviderData.medicalProvider);
    const proccessedMedicalRecordsStored = useSelector(state => state.preProcessMedicalRecords.injuryData);
    const summaryLoadingPercentage = useSelector(state => state.preProcessMedicalRecords.summaryLoadingPercentage);
    const caseAdditionalData = useSelector(state => state?.caseInformation?.caseAdditionalData);
    const [isShowReorderSec, setShowReorderSec] = useState(false); // for show reorder section

    useEffect(() => {
        dispatch(formikRefCapture(innerRef))
    }, [])


    const [fileErrorList, setFileErrorList] = useState([]);
    const validate = (medicalRecords) => {
        const errors = [];
        if (medicalRecords.postAccident && medicalRecords.postAccident.length > 0) {
          medicalRecords.postAccident.forEach((record, index) => {
            if (record.medicalRecords && record.medicalRecords.length > 0) {
              if (!record.providerName || record.providerName.trim() === '') {
                errors.push(`Post-accident record #${index + 1} is missing provider name`);
              }
            }
          });
        }
        
        if (medicalRecords.preAccident && medicalRecords.preAccident.length > 0) {
          medicalRecords.preAccident.forEach((record, index) => {
            if (record.medicalRecords && record.medicalRecords.length > 0) {
              if (!record.providerName || record.providerName.trim() === '') {
                errors.push(`Pre-accident record #${index + 1} is missing provider name`);
              }
            }
          });
        }
        
        return errors;
    }

    const getHasUserUploadedAnyMedicalRecords = (clientMedicalFiles)=>{
        console.log("Testing client medical files: ", clientMedicalFiles);
        return clientMedicalFiles && (clientMedicalFiles.postMedicalFiles?.medicalRecords?.length || clientMedicalFiles.preMedicalFiles?.medicalRecords?.length);
    }

    const saveDataToStore = (values = {}, isGenerateMedicalSummaryClick = false) => {
        const allMedicalRecords = values?.medicalFiles?.map((file, index) => ({
            postAccident: file.postMedicalFiles,
            preAccident: file.preMedicalFiles,
        })) || [];
    
        for (let record of allMedicalRecords) {
            const errors = validate({
                postAccident: record.postAccident,
                preAccident: record.preAccident
            });
    
            if (errors.length > 0) {
                toaster({ message: `Plaintiff ${record.index + 1}: ${errors[0]}`, success: false });
                return { medicalRecords: null, success: false };
            }
        }
        if (isGenerateMedicalSummaryClick) {
            dispatch(preProcessedMedicalRecordsData({
                ...proccessedMedicalRecordsStored,
                isPreProcessRecordLoading: true,
            }));
        }

        dispatch(storeMedicalProvider({ medicalFiles :allMedicalRecords }))
        return {  medicalRecords: { medicalFiles :allMedicalRecords }, success: true }
    }

    const onFormikSubmitHandler = (values, isGenerateMedicalSummaryClick = false) => {
        const {medicalRecords, success} = saveDataToStore(values, isGenerateMedicalSummaryClick)     
        if (!success) return
        onSubmit({
            medicalProviders: medicalRecords,
            isDraftCase: isGenerateMedicalSummaryClick
        })

    }

    const handlePrevious = (values) => {
        saveDataToStore(values);
        stepDecrement();
    };

    const viewMedicalRecords = (e, value) => {
        e.preventDefault()
        setIsOpenProcessedMedicalRecordsModal(true)
    }

    const closeMedicalSummaryRecordModel = () => {
        setIsOpenProcessedMedicalRecordsModal(false)
    }

    const providerSections = [
        {
            providerType: "postMedicalFiles",
            heading: "Post-Accident Medical Providers",
            reorderHeading: "Reorder Post-Accident Related Medical Providers",
            tempProviderType: "postAccident"
        },
        {
            providerType: "preMedicalFiles",
            heading: "Prior Medical Records",
            reorderHeading: "Reorder Pre-Accident Related Medical Providers",
            tempProviderType: "preAccident"
        }
    ];

    
    const isMedicalRecordsGeneratedPreviously = useMemo(() => {
        console.log("Selected tiff index ", selectedTiffIndex);
        console.log("Plaintiffs: ", plainTiffs);
        console.log("Medical records stored: ", proccessedMedicalRecordsStored);
        const filterClientsMedicalData = proccessedMedicalRecordsStored?.medicalProcessedData?.find(
            (client) => client.clientId === plainTiffs[selectedTiffIndex]?.clientId
        );
        return (
            (filterClientsMedicalData?.preMedicalRecords?.length ?? 0) > 0 ||
            (filterClientsMedicalData?.medicalRecords?.length ?? 0) > 0 ||
            (filterClientsMedicalData?.medicalBillRecords?.length ?? 0) > 0
        );
    }, [proccessedMedicalRecordsStored, plainTiffs, selectedTiffIndex]);
    
    const medicalFilesData = medicalProviderData?.medicalFiles ?? [];
    return (
        <>
            <Formik
                initialValues={{
                    medicalFiles : Array.from({ length: plainTiffs.length }, (_, i) => {
                        return medicalFilesData[i] ? {
                            postMedicalFiles:  medicalFilesData[i]?.postAccident || {medicalRecords: []},
                            preMedicalFiles: medicalFilesData[i]?.preAccident || {medicalRecords: []},
                            postAccident: { providerName: "", medicalRecords: [] },
                            preAccident: { providerName: "", medicalRecords: [] }
                        } :  {
                            postMedicalFiles: {medicalRecords: []},
                            preMedicalFiles: {medicalRecords:[]},
                            postAccident: { providerName: "", medicalRecords: [] },
                            preAccident: { providerName: "", medicalRecords: [] }
                        };
                    })
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    dispatch(cancelCaseSubmission(true))
                    dispatch(isCaseSaved(false))
                    onFormikSubmitHandler(values)
                }}
            >
                {({ setFieldValue, values,handleChange }) => (
                    <Form onKeyDown={(e) => handleEnterKeyPress(e)}>
                        {providerSections.map(section => (
                            <ReorderMedicalProvider
                            key={section.providerType}
                            heading={section.reorderHeading}
                            providerType={section.providerType}
                            setFieldValue={setFieldValue}
                            formikValues={values}
                            selectedTiffIndex={selectedTiffIndex}
                            isShowReorderSec={isShowReorderSec[section.providerType]}
                            setShowReorderSec={setShowReorderSec}
                            />
                        ))}

                        {!isShowReorderSec.preMedicalFiles && !isShowReorderSec.postMedicalFiles && <div className="add-med-form p-0">
                            <div className="accordion form-background form-item-pd" >
                              {providerSections.map(section => (
                                    <MedicalProviderSec
                                        key={section.providerType}
                                        providerType={section.providerType}
                                        heading={section.heading}
                                        tempProviderType={section.tempProviderType}
                                        setFieldValue={setFieldValue}
                                        formikValues={values}
                                        selectedTiffIndex={selectedTiffIndex}
                                        handleChange={handleChange}
                                        setFileErrorList={setFileErrorList}
                                        setShowReorderSec={setShowReorderSec}
                                    />
                                ))}

                                {/* Generatr Pre medical  */}
                                <div className="summary-section mt-5 mb-3">
                                    <div className="gen-text">
                                        <span className="fw-bold">Medical Summary</span>

                                        {proccessedMedicalRecordsStored?.isPreProcessRecordLoading && <div className="custom-bar mt-4">
                                            <div className="d-flex align-items-center gap-1">
                                                {`${summaryLoadingPercentage || 0}%`}
                                                <div className="progress">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${summaryLoadingPercentage}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            <small className="mt-1">Generating medical summary can take 5 to 15 minutes...</small>
                                        </div>}

                                        <div className='d-flex gap-2'>
                                            <button id="summaryBtn" type='button' className="btn btn-theme btn-white d-flex align-items-center"
                                                disabled={proccessedMedicalRecordsStored?.isPreProcessRecordLoading || caseAdditionalData?.isDisableSubmitButton || !getHasUserUploadedAnyMedicalRecords(values.medicalFiles[selectedTiffIndex])}
                                                onClick={(e) => onFormikSubmitHandler(values, true)}
                                            >
                                                <span className="me-2">
                                                    {proccessedMedicalRecordsStored?.isPreProcessRecordLoading ?
                                                        <div className="medical-summary-spinner"></div>
                                                        : <MedicalSummaryButtonIcon />}
                                                </span>
                                                {isMedicalRecordsGeneratedPreviously ? "Regenerate" : "Generate Medical Summary"}
                                            </button>

                                            <RenderIf shouldRender={isMedicalRecordsGeneratedPreviously}>
                                                <button type='button'
                                                    className="btn btn-theme btn-border"
                                                    onClick={(e) => viewMedicalRecords(e, true)}>
                                                    View Medical Summary
                                                </button>
                                            </RenderIf>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <CaseFormFooter backToCases={backToCases} handlePrevious={handlePrevious} innerRef={innerRef}  formSteps={formSteps} values={values}/>
                        </div>}
                    </Form>
                )
                }
            </Formik>
            <RenderIf shouldRender={isOpenProcessedMedicalRecordsModal}>
                <MedicalViewSummaryModal
                    proccessedMedicalRecordsStored={proccessedMedicalRecordsStored}
                    isOpenProcessedMedicalRecordsModal={isOpenProcessedMedicalRecordsModal}
                    closeMedicalSummaryRecordModel={closeMedicalSummaryRecordModel}
                    plainTiffs={plainTiffs}
                    caseId={caseId}
                    selectedTiffIndex={selectedTiffIndex}
                    setSelectedTiffIndex={setSelectedTiffIndex}
                />
            </RenderIf>
            {fileErrorList.length ? <FileUploadErrorModal fileErrorList={fileErrorList} setFileErrorList={setFileErrorList} /> : ""}
        </>
    )


}

export default AddMedicalProviderBillForm;